
export default function ComplianceSection() {
  const certifications = [
    {
      name: 'QCDD',
      description: 'Qatar Civil Defence Directorate Approved',
      icon: 'ri-shield-check-line',
      color: 'text-green-600 bg-green-100'
    },
    {
      name: 'EN3',
      description: 'European Standard for Portable Fire Extinguishers',
      icon: 'ri-award-line',
      color: 'text-blue-600 bg-blue-100'
    },
    {
      name: 'ISO 9001',
      description: 'Quality Management System Certified',
      icon: 'ri-medal-line',
      color: 'text-purple-600 bg-purple-100'
    },
    {
      name: 'NFPA',
      description: 'National Fire Protection Association Standards',
      icon: 'ri-fire-line',
      color: 'text-red-600 bg-red-100'
    }
  ];

  const standards = [
    'EN3-7: Portable fire extinguishers - Characteristics, performance requirements and test methods',
    'BS EN3: British Standard for portable fire extinguishers',
    'QCDD Technical Requirements for Fire Fighting Equipment',
    'ISO 11602: Fire protection - Foam concentrates and foam solutions',
    'NFPA 10: Standard for Portable Fire Extinguishers'
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Certifications & Compliance</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our foam fire extinguishers meet international safety standards and local regulations
          </p>
        </div>

        {/* Certifications Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {certifications.map((cert, index) => (
            <div key={index} className="text-center p-6 bg-gray-50 rounded-xl hover:shadow-lg transition-shadow">
              <div className={`w-16 h-16 ${cert.color} rounded-full flex items-center justify-center mx-auto mb-4`}>
                <i className={`${cert.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{cert.name}</h3>
              <p className="text-sm text-gray-600">{cert.description}</p>
            </div>
          ))}
        </div>

        {/* Standards Compliance */}
        <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-2xl p-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Compliance Standards</h3>
              <ul className="space-y-3">
                {standards.map((standard, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <div className="flex-shrink-0 w-6 h-6 bg-red-100 rounded-full flex items-center justify-center mt-0.5">
                      <i className="ri-check-line text-red-600 text-sm"></i>
                    </div>
                    <span className="text-gray-700">{standard}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Quality Assurance</h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-3 p-4 bg-white rounded-lg">
                  <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                    <i className="ri-test-tube-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Factory Testing</h4>
                    <p className="text-sm text-gray-600">100% pressure tested before shipment</p>
                  </div>
                </div>

                <div className="flex items-center space-x-3 p-4 bg-white rounded-lg">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <i className="ri-file-list-3-line text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Documentation</h4>
                    <p className="text-sm text-gray-600">Complete certification and test reports</p>
                  </div>
                </div>

                <div className="flex items-center space-x-3 p-4 bg-white rounded-lg">
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <i className="ri-customer-service-2-line text-purple-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Support</h4>
                    <p className="text-sm text-gray-600">Technical support and maintenance services</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
